import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions, RequestMethod } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class BackgroundDashboardService {
    headers: Headers;
    options: RequestOptions;
    baseAPIurl: string = '';
    public AfterAgreeInSignaturePage: boolean = false;

    constructor(private _http: Http, private _httpClient: HttpClient) {
        this.baseAPIurl = environment.baseAPIUrl;
    }
    
    getToken() {
        const token = localStorage.getItem('AccessToken');
        if (token != null) {
            const bearerToken = 'Bearer ' + token;
            let newHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

            newHeaders = newHeaders.append('Authorization', bearerToken);

            return newHeaders;
        }
    }

    UpdateSignature(Email: string, DrawSignature: string, SignatureType: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/UpdateSignature?Email=' + Email + '&DrawSignature=' + btoa(DrawSignature) +
            '&SignatureType=' + SignatureType, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    UserBackgroundDetails(Email: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/UserBackgroundDetails?Email=' + Email, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }


    private handleError(error: Response) {
        return Observable.throw(error.json().error || 'Server error');
    }

    GetUnselectServicesInAddSearch(): Observable<any> {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetUnselectServicesInAddSearch', { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetPackageDetails(PackageId: number): Observable<any> {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetPackageDetails?PackageId=' + PackageId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    ImpressEmployerGenerateEmail(EnterEmailId: string, LoginId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/ImpressEmployerGenerateEmail?EnterEmailId=' + EnterEmailId + '&LoginId='
            + LoginId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetJurisdiction(JuridicationModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl +
            'BackgroundDashboard/GetJurisdiction', JuridicationModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetUserJuridiction(EmailId) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetUserJuridiction?EmailId=' + EmailId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    InsertIntoSubjectAddress(CountryCheckModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl +
            'BackgroundDashboard/InsertIntoSubjectAddress', CountryCheckModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetViewProgress(OrderId: any): Observable<any> {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetViewProgress?OrderId=' + OrderId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    IsOrderReportTokenExit(OrderToken: string, SenderEmailId: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/IsOrderReportTokenExit?OrderToken=' + OrderToken + '&SenderEmailId=' + SenderEmailId,
            { headers: this.getToken() });
    }

    ViewReportOrder(OrderId: string, ServiceId: number): Observable<any> {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/ViewReportOrder?OrderId=' + OrderId + '&ServiceId=' + ServiceId, { headers: this.getToken() })
    }

    IsEmployementRecordAlreadyExist(EmployementModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl +
            'BackgroundDashboard/IsEmployementRecordAlreadyExist', EmployementModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    IsEducationRecordAlreadyExist(EducationModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl +
            'BackgroundDashboard/IsEducationRecordAlreadyExist', EducationModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    IsProfessionalLicenseAlreadyExist(ProfessionalLicenseModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + 'BackgroundDashboard/IsProfessionalLicenseAlreadyExist',
            ProfessionalLicenseModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    IsServiceCompletedTheInformationOrPending(ServiceId: number, OrderId: string, IsCompletedDetails: boolean, WorkPastId: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/IsServiceCompletedTheInformationOrPending?ServiceId=' + ServiceId + '&OrderId=' + OrderId
            + '&IsCompletedDetails=' + IsCompletedDetails + '&WorkPastId=' + WorkPastId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }



    GetEmployerHistoryForSavingRecord(WorkPastId: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetEmployerHistoryForSavingRecord?WorkPastId=' + WorkPastId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetEducationHistoryForSavingRecord(WorkPastId: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetEducationHistoryForSavingRecord?WorkPastId=' + WorkPastId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetProfessionalHistoryForSavingRecord(WorkPastId: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetProfessionalHistoryForSavingRecord?WorkPastId=' + WorkPastId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    InsertIntoEmployementHistory(EmployementModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl +
            'BackgroundDashboard/InsertIntoEmployementHistory', EmployementModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    InsertIntoEducationVerification(EducationModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + 'BackgroundDashboard/InsertIntoEducationVerification',
            EducationModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    UpdatedIntoOrderTableForProfessional(ProfessionalLicenseModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + 'BackgroundDashboard/UpdatedIntoOrderTableForProfessional',
            ProfessionalLicenseModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    UpdatedTheServiceStatus(ViewOrderModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + 'BackgroundDashboard/UpdatedTheServiceStatus',
            ViewOrderModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    OrderReport(EmailId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/OrderReport?EmailId=' + EmailId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }


    GetViewOrderForSSTrace(OrderId: string, ServiceId: number): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/GetViewOrderForSSTrace?OrderId=' +
            OrderId + '&ServiceId=' + ServiceId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    CheckCriminalHistoryService(OrderId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/CheckCriminalHistoryService?OrderId=' +
            OrderId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    CheckMiscHistoryService(OrderId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/CheckMiscHistoryService?OrderId=' +
            OrderId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    CheckEducationService(OrderId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/CheckEducationService?OrderId=' +
            OrderId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    CheckEmploymentService(OrderId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/CheckEmploymentService?OrderId=' +
            OrderId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }


    GetAccountDetails(EmailId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/GetAccountDetails?EmailId=' +
            EmailId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetFAQRecord(): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/GetFAQRecord', { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    RevokeAccesbilityViewOrderReport(Id): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/RevokeAccesbilityViewOrderReport?Id=' + Id,
            { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetOrderReportDetails(ApplicantEmailId): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/GetOrderReportDetails?ApplicantEmailId=' + ApplicantEmailId,
            { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetStatusOfOrder(OrderId: any): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/GetStatusOfOrder?OrderId=' + OrderId,
            { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    InsertTransactionDetails(TransactionModel: any): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + 'BackgroundDashboard/InsertTransactionDetails', TransactionModel,
            { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetTransactionDetails(EmailId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundDashboard/GetTransactionDetails?EmailId=' + EmailId,
            { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }


    IsServiceCompletedForOtherService(ServiceId: number, OrderId: string, IsCompletedDetails: boolean, WorkPastId: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/IsServiceCompletedForOtherService?ServiceId=' + ServiceId + '&OrderId=' + OrderId
            + '&IsCompletedDetails=' + IsCompletedDetails + '&WorkPastId=' + WorkPastId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }


    OrderConfirmationEmail(array) {
        return this._httpClient.post(this.baseAPIurl +
            'BackgroundDashboard/OrderConfirmationEmail', array, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }


    GetAddressDetails(OrderId: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetAddressDetails?OrderId=' + OrderId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetEmailforAttachPdfSignature(EmailId: string, OrderId: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetEmailforAttachPdfSignature?EmailId=' + EmailId + '&OrderId=' + OrderId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    CreateNewOrderInParentDatabase(Model) {
        return this._httpClient.post(this.baseAPIurl +
            'BackgroundDashboard/CreateNewOrderInParentDatabase', Model, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    AdditionalEmploymentDetails(EmployerHistoryModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + 'BackgroundCheck/AdditionalEmploymentDetails',
            EmployerHistoryModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    AdditionalEducationalDetails(EducationHistoryModel): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + 'BackgroundCheck/AdditionalEducationalDetails',
            EducationHistoryModel, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    InsertAndUpdateUserSetting(EmailId: string, EmailUpdateStatus: boolean, SMSUpdateStatus: boolean) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/InsertAndUpdateUserSetting?EmailId=' + EmailId + '&EmailUpdateStatus=' + EmailUpdateStatus + '&SMSUpdateStatus=' + SMSUpdateStatus, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetUserSetting(EmailId) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/GetUserSetting?EmailId=' + EmailId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );

    }

    UpdateFeeApproval(OrderId, Status) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/UpdateFeeApproval?OrderId=' + OrderId + '&Status=' + Status, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );

    }

    CheckRecordFromFeeApprovalDetails(OrderId) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundDashboard/CheckRecordFromFeeApprovalDetails?OrderId=' + OrderId, { headers: this.getToken() })
            .pipe(
                catchError(this.handleError)
            );

    }

}
